/* @jsx m */
import m from 'mithril';
import DeviceWrapper from '../components/DeviceWrapper.jsx';
import AppHeader from '../components/AppHeader.jsx';
import StatusBar from '../components/StatusBar.jsx';

export default function preferences() {
  return {
    view: () => {
      return (
        <DeviceWrapper>
        <StatusBar />
        <AppHeader />
        <div class="center-align" id="prefs">
          <form id="preferencesForm">
            <ul class="menu">
              <h2>Preferences</h2>
              <span class="notify"></span>
              <li class="menu-item">
                <div class="form-group">
                  <label class="form-radio form-inline">
                    <input type="radio" name="delay" value="slow" /><i
                      class="form-icon"
                    ></i>
                    Slow
                  </label>
                  <label class="form-radio form-inline">
                    <input
                      type="radio"
                      name="delay"
                      checked=""
                      value="normal"
                    /><i class="form-icon"></i>
                    Normal
                  </label>
                  <label class="form-radio form-inline">
                    <input type="radio" name="delay" value="fast" /><i
                      class="form-icon"
                    ></i>
                    Fast
                  </label>
                </div>
              </li>
              <li class="menu-item">
                <a class="btn btn-link" href="#/menu">
                  Back
                </a>
              </li>
            </ul>
          </form>
        </div>
      </DeviceWrapper>
      );
    }
  }
}